import { render, staticRenderFns } from "./employees_page.vue?vue&type=template&id=67335e19"
import script from "./employees_page.vue?vue&type=script&lang=js"
export * from "./employees_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports